import { IMessageChunk } from "../types";

export const formatResponseChunk = (chunk: string) => {
  return JSON.parse(chunk.replace(/^data:\s*/, "")) as IMessageChunk;
};
